const moreGroups = document.querySelectorAll(".more-group");

if (moreGroups) {
    moreGroups.forEach(moreGroup => {
        const moreBtn = moreGroup.querySelector(".more-btn");
        const moreContent = moreGroup.querySelector(".more-content");

        moreBtn.addEventListener("click", () => {
            const moreBtnOn = moreBtn.querySelector(".more-btn-on");
            const moreBtnOff = moreBtn.querySelector(".more-btn-off");

            if (moreBtn.getAttribute("aria-pressed") === "false") {
                moreBtn.setAttribute("aria-pressed", "true");
                moreBtnOn.setAttribute("aria-hidden", "true");
                moreBtnOff.setAttribute("aria-hidden", "false");
                moreContent.setAttribute("aria-hidden", "false");
            } else {
                moreBtn.setAttribute("aria-pressed", "false");
                moreBtnOn.setAttribute("aria-hidden", "false");
                moreBtnOff.setAttribute("aria-hidden", "true");
                moreContent.setAttribute("aria-hidden", "true");
            }
        })
    });
}